import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
        <Link to="/" style={styles.logo}>
          <img src="/logo.jpg" alt="GlowFlex" style={styles.logoImg} />
          <span style={styles.logoText}>GlowFlex</span>
        </Link>

        {/* Hamburger Button */}
        <div 
          onClick={toggleMenu} 
          style={styles.hamburger}
        >
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
        </div>

        {/* Desktop Nav */}
        <div style={styles.desktopNav}>
          <Link to="/" style={styles.navLink}>Home</Link>
          <Link to="/activities" style={styles.navLink}>Activities</Link>
          <Link to="/menu" style={styles.navLink}>Menu</Link>
          <Link to="/contact" style={styles.navLink}>Contact</Link>
          
          {user ? (
            <>
              <span style={styles.userName}>Hi, {user.name.split(' ')[0]}!</span>
              <Link to="/my-bookings" style={styles.navLink}>My Bookings</Link>
              {user.role === 'admin' && (
                <Link to="/admin" style={styles.navLink}>Admin</Link>
              )}
              <button onClick={logout} style={styles.logoutBtn}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" style={styles.navLink}>Login</Link>
              <Link to="/register" style={styles.signupBtn}>Sign Up</Link>
            </>
          )}
        </div>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <>
            <div style={styles.overlay} onClick={closeMenu}></div>
            <div style={styles.mobileMenu}>
              <Link to="/" style={styles.mobileLink} onClick={closeMenu}>Home</Link>
              <Link to="/activities" style={styles.mobileLink} onClick={closeMenu}>Activities</Link>
              <Link to="/menu" style={styles.mobileLink} onClick={closeMenu}>Menu</Link>
              <Link to="/contact" style={styles.mobileLink} onClick={closeMenu}>Contact</Link>
              
              {user ? (
                <>
                  <div style={styles.mobileUserName}>Hi, {user.name.split(' ')[0]}!</div>
                  <Link to="/my-bookings" style={styles.mobileLink} onClick={closeMenu}>My Bookings</Link>
                  {user.role === 'admin' && (
                    <Link to="/admin" style={styles.mobileLink} onClick={closeMenu}>Admin</Link>
                  )}
                  <button onClick={() => { logout(); closeMenu(); }} style={styles.mobileLogoutBtn}>
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" style={styles.mobileLink} onClick={closeMenu}>Login</Link>
                  <Link to="/register" style={styles.mobileSignupBtn} onClick={closeMenu}>
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

const styles = {
  navbar: {
    background: '#E75A7C',
    padding: '0.75rem 0',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    textDecoration: 'none',
    color: 'white',
    zIndex: 1001
  },
  logoImg: {
    height: '45px',
    width: '45px',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  logoText: {
    fontSize: '1.4rem',
    fontWeight: 700,
    fontFamily: 'Playfair Display, serif'
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    gap: '5px',
    cursor: 'pointer',
    zIndex: 1001,
    padding: '10px'
  },
  bar: {
    width: '28px',
    height: '3px',
    background: 'white',
    borderRadius: '2px'
  },
  desktopNav: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem'
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '0.95rem'
  },
  userName: {
    color: 'white',
    fontWeight: 600,
    fontSize: '0.95rem'
  },
  signupBtn: {
    background: 'white',
    color: '#E75A7C',
    padding: '0.5rem 1.25rem',
    borderRadius: '25px',
    fontWeight: 600,
    textDecoration: 'none',
    display: 'inline-block'
  },
  logoutBtn: {
    background: 'transparent',
    color: 'white',
    border: '2px solid white',
    padding: '0.4rem 1rem',
    borderRadius: '20px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '0.9rem'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 1001
  },
  mobileMenu: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '75%',
    maxWidth: '300px',
    height: '100vh',
    background: '#E75A7C',
    display: 'flex',
    flexDirection: 'column',
    padding: '80px 2rem 2rem',
    gap: '1.5rem',
    zIndex: 1002,
    overflowY: 'auto',
    boxShadow: '-2px 0 10px rgba(0,0,0,0.3)'
  },
  mobileLink: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '1.1rem',
    padding: '0.5rem 0',
    borderBottom: '1px solid rgba(255,255,255,0.2)'
  },
  mobileUserName: {
    color: 'white',
    fontWeight: 700,
    fontSize: '1.2rem',
    paddingBottom: '0.5rem',
    borderBottom: '2px solid white'
  },
  mobileSignupBtn: {
    background: 'white',
    color: '#E75A7C',
    padding: '0.75rem 1.5rem',
    borderRadius: '25px',
    fontWeight: 700,
    textDecoration: 'none',
    textAlign: 'center',
    marginTop: '1rem'
  },
  mobileLogoutBtn: {
    background: 'transparent',
    color: 'white',
    border: '2px solid white',
    padding: '0.75rem 1.5rem',
    borderRadius: '25px',
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: '1rem',
    marginTop: '1rem'
  }
};

// Media queries
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @media (max-width: 768px) {
    nav > div > div:nth-child(2) {
      display: flex !important;
    }
    nav > div > div:nth-child(3) {
      display: none !important;
    }
  }
  
  @media (min-width: 769px) {
    nav > div > div:nth-child(2) {
      display: none !important;
    }
  }
`;
if (!document.getElementById('navbar-styles')) {
  styleSheet.id = 'navbar-styles';
  document.head.appendChild(styleSheet);
}

export default Navbar;